import React, {Component} from 'react'
import DawidPagination from "./pagination.jsx";
import './loops_navigation.css'
import {LOOPS_COMPONENTS_SEPARATOR} from "../utils.js";
import {isDecisionOnlyIteration} from "../items/utils";

export class LoopsNavigation extends Component {


    extractParentLoops() {
        const parentLoops = Array();
        // we have to look for parent loops
        for (const loopName in this.props.loops) {
            if (Object.prototype.hasOwnProperty.call(this.props.loops, loopName)) {
                if (loopName !== this.props.currentLoopName && this.props.currentLoopName.startsWith(loopName)) {
                    parentLoops.push(loopName);
                }
            }
        }
        parentLoops.sort();
        return parentLoops;
    }


    shortLoopName(loopName) {
        const {loopsDefinitions} = this.props;
        // remove parent loop name
        let shortName = loopName.substring(loopName.lastIndexOf(LOOPS_COMPONENTS_SEPARATOR) + 1);
        if (shortName === undefined) {
            shortName = loopName;
        }
        // remove suffix loop name (from parent loop counter)
        shortName = shortName.substring(0, shortName.lastIndexOf('$')) || shortName;
        if (loopsDefinitions) {
            if (shortName in loopsDefinitions) {
                shortName = loopsDefinitions[shortName]["name"]
            } else {
                shortName = "Loop " + shortName;
            }
        }
        return shortName;
    }

    hideIteration(parentLoopName, iteration) {
        const loop = this.props.loops[parentLoopName];
        if (loop.index - 1 === iteration) {
            return false; // we always show the current active iteration
        }
        return isDecisionOnlyIteration(loop, iteration)
    }

    render() {
        const {currentLoopName, loops, onPageChange} = this.props;
        const parentLoops = this.extractParentLoops();
        const shortLoopName = this.shortLoopName(currentLoopName);
        const loopIndex = loops[currentLoopName].index;
        const maxLoopIndex = loops[currentLoopName].states.length;
        const validIterations = loops[currentLoopName].validIterations;
        return (
            <div className={'loopsNavigation'}>
                {parentLoops.map((parentLoopName) => {
                        const loopParent = loops[parentLoopName];
                        const loopParentIndex = loopParent.index;
                        const maxLoopParentIndex = loopParent.states.length;
                        const parentValidIterations = loopParent.validIterations;
                        const shortParentLoopName = this.shortLoopName(parentLoopName);
                        return (
                            <div key={"parentLoop-" + parentLoopName}>
                                <DawidPagination
                                    getIterationName={(iteration) => this.props.getIterationName(parentLoopName, iteration)}
                                    hideIteration={(iteration) => this.hideIteration(parentLoopName, iteration)}
                                    loopName={parentLoopName}
                                    activePage={loopParentIndex}
                                    firstItem={null}
                                    lastItem={null}
                                    nextItem={null}
                                    onPageChange={onPageChange}
                                    totalPages={maxLoopParentIndex}
                                    completed={parentValidIterations}
                                    maxLength={10}
                                />
                                <span>{shortParentLoopName}</span>
                            </div>
                        );
                    }
                )
                }
                {/* deepest loop */}
                <div>
                    <DawidPagination
                        hideIteration={(iteration) => this.hideIteration(currentLoopName, iteration)}
                        getIterationName={(iteration) => this.props.getIterationName(currentLoopName, iteration)}
                        loopName={currentLoopName}
                        activePage={loopIndex}
                        firstItem={null}
                        lastItem={null}
                        nextItem={null}
                        onPageChange={onPageChange}
                        totalPages={maxLoopIndex}
                        completed={validIterations}
                        maxLength={10}
                    />
                    <span>{shortLoopName}</span>
                </div>
            </div>
        )
    }
}


